import { Step } from "./Step";
import { StepTypes } from "../../enum/StepTypes";

export class DefaultStep extends Step {
    constructor(step: any) {
        super(step);
        this._name = StepTypes.translations[step.type].name;
    }
}